import i18n from '@/i18n'
import Index from './index'
import Preference from './preference'
import QuestionIndex from './question/index'
import Question from './question/question'

const basePath = '/recruiting/company/:companyId'

export default {
  name: 'surveyIndex',
  path: `${basePath}/survey`,
  component: Index,
  redirect: `${basePath}/survey/preference`,
  meta: {
    noAuth: true
  },
  children: [
    {
      name: 'surveyPreference',
      path: `${basePath}/survey/preference`,
      component: Preference,
      meta: {
        get title () {
          return i18n.t('survey.title.preference')
        }
      }
    },
    {
      name: 'surveyQuestionIndex',
      path: `${basePath}/survey/question`,
      component: QuestionIndex,
      redirect: `${basePath}/survey/question/1`,
      children: [
        {
          name: 'surveyQuestionStep',
          path: `${basePath}/survey/question/:step`,
          component: Question,
          meta: {
            get title () {
              return i18n.t('survey.title.surveyQuestion')
            }
          }
        }
      ]
    }
  ]
}
